import type {Plugin} from 'vue';

type Env = 'dev' | 'live' | string;

const SegmentAnalytics: Plugin = {
  install() {
    if (typeof document === 'undefined') return; // SSR guard

    const env = import.meta.env.VITE_APP_ENV as Env;
    const writeKey =
      env === 'live'
        ? 'NLdnnJxNxMajUyFjjjWP3tBAAiwUgRSO'
        : 'hbMk6mAbcE5502M25ovLOhNIhedDVnjQ';

    const code = `
!function(){
  var analytics = window.analytics = window.analytics || [];
  if (!analytics.initialize) if (analytics.invoked) {
    window.console && console.error && console.error("Segment snippet included twice.");
  } else {
    analytics.invoked = true;
    analytics.methods = ["trackSubmit","trackClick","trackLink","trackForm","pageview","identify","reset","group","track","ready","alias","debug","page","once","off","on"];
    analytics.factory = function(t){ return function(){ var e = Array.prototype.slice.call(arguments); e.unshift(t); analytics.push(e); return analytics } };
    for (var t=0; t<analytics.methods.length; t++){ var e = analytics.methods[t]; analytics[e] = analytics.factory(e) }
    analytics.load = function(t,e){ var n = document.createElement("script"); n.type="text/javascript"; n.async=true; n.src="https://cdn.segment.com/analytics.js/v1/"+t+"/analytics.min.js"; var a=document.getElementsByTagName("script")[0]; a.parentNode.insertBefore(n,a); analytics._loadOptions=e };
    analytics.SNIPPET_VERSION = "4.1.0";
    analytics.load("${writeKey}");
  }
}();`;

    const script = document.createElement('script');
    script.appendChild(document.createTextNode(code));
    document.head.appendChild(script);
  },
};

export default SegmentAnalytics;
